/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Reason_Accredited_TextInputs */



/**
* | output |
* | --- |
* | "OCIMF accredited inspectors, working under ISO 9001 and ISO 45001." |
*
* @param {Home_Reason_Accredited_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_reason_accredited_text = /** @type {((inputs?: Home_Reason_Accredited_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Reason_Accredited_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("OCIMF 认证检查员，依照 ISO 9001 和 ISO 45001 体系开展工作。")
	return /** @type {LocalizedString} */ ("OCIMF accredited inspectors, working under ISO 9001 and ISO 45001.")
});